import type { ReactNode } from "react"

import { BottomDock } from "@/components/marketplace/layout/bottom-dock"
import { withPalette, type Palette } from "@/components/marketplace/palette"

interface AppShellProps {
  children: ReactNode
  header: ReactNode
  fullHeight?: boolean
  palette?: Palette
  bottomNav?: boolean
  skipLink?: ReactNode
  footer?: ReactNode
}

// The floating bar's clearance sits under the footer when there is one, so the band it leaves is
// the footer's white rather than the page canvas.
const navClearance = "pb-nav-clear dock-clearance lg:pb-0"

export const AppShell = ({ children, header, fullHeight = false, palette, bottomNav = false, skipLink, footer }: AppShellProps) => (
  <div data-app-shell="" data-bottom-nav={bottomNav ? "" : undefined} className={`group/shell relative isolate flex flex-col ${fullHeight ? "min-h-dvh" : ""}`}>
    {skipLink}
    <header className={`z-sticky ${bottomNav ? "relative" : "sticky top-0"}`}>{header}</header>
    <div
      id="main-content"
      tabIndex={-1}
      className={withPalette(
        palette,
        `focus:outline-none ${bottomNav ? "sticky-chrome-none" : "sticky-chrome-bar lg:sticky-chrome-wide"} bg-palette-canvas @container/shell flex flex-1 flex-col ${bottomNav && !footer ? navClearance : ""}`
      )}
    >
      {children}
      {footer && <div className={`shell-foot ${bottomNav ? `bg-surface ${navClearance}` : ""}`}>{footer}</div>}
    </div>
    {!bottomNav && <BottomDock />}
  </div>
)
